// Client-side validation utilities

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isEmailAddress(value: string): boolean {
  return EMAIL_REGEX.test(value.trim());
}

// A valid name must be at least 5 characters and contain at least one
// internal space (e.g. a first and last name like "John Doe").
export function isValidName(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length >= 5 && /\s/.test(trimmed);
}
